import { useParams } from 'react-router-dom';

export default function useId(
	param: string | string[] = 'id',
): any { // @TODO: TS
	const params = useParams();

	return Array.isArray(param)
		? Object.fromEntries(param.map((item) => [
			item,
			+params[item],
		])) : +params[param];
}
